<agpr-take-over-panel
    [id]="id"
    [header]="'Discover.RR.quickEditPanel.header'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    class="agpr-quickEditPanel-overlay"
    (visibleChange)="close()"
>
    <div
        class="agpr-quickEditPanel"
        [agprLoading]="loading"
    >
        <div class="agpr-quickEditPanel-leftSide">
            <agpr-scroll-panel>
                <div class="agpr-quickEditPanel-leftSide-copilot">
                    <div class="agpr-quickEditPanel-leftSide-copilot-icon">
                        <i class="fa-kit-duotone fa-agpr-ai-contacts"></i>
                    </div>

                    <div class="agpr-quickEditPanel-leftSide-copilot-text">
                        {{ 'Discover.recommendedSearchSummary.agilityAgent.analyzed' | localize }}
                    </div>
                </div>
                <div class="agpr-quickEditPanel-leftSide-selectAll">
                    <ng-container>
                        <agpr-button
                            id="quickEditPanel.toggleButton"
                            [style]="buttonTypes.link"
                            [label]="searchModel.equals(defaultSearchModel) ? 'selectNone' : 'selectAll'"
                            (click)="searchModel.equals(defaultSearchModel) ? uncheckAll() : checkAll()"
                        ></agpr-button>
                    </ng-container>
                </div>

                <div class="agpr-quickEditPanel-leftSide-preSelected">
                    <!-- areasOfCoverage -->
                    <ng-container *ngIf="searchIncludeExcludeNotEmpty?.areasOfCoverage">
                        <label class="agpr-quickEditPanel-leftSide-label">
                            {{ 'Discover.targeting.searchFieldLabels.targetAudienceRegion' | localize }}
                        </label>
                        <div class="agpr-quickEditPanel-leftSide-details">
                            @for (areasOfCoverage of defaultSearchModel.areasOfCoverage.include; track areasOfCoverage) {
                                <agpr-checkbox
                                    [value]="areasOfCoverage"
                                    [id]="id + '_areasOfCoverage_' + areasOfCoverage"
                                    [(ngModel)]="searchModel.areasOfCoverage.include"
                                    labelLookupValue="displayString"
                                    labelLookupKey="collectionId"
                                    [labelLookup]="journodexRegionsService.getByGeographyIds.bind(journodexRegionsService)"
                                    (onChange)="handleToggle($event, 'areasOfCoverage')"
                                >
                                </agpr-checkbox>
                            }
                        </div>
                    </ng-container>

                    <!-- mediaMarkets -->
                    <ng-container *ngIf="searchIncludeExcludeNotEmpty?.mediaMarkets">
                        <label class="agpr-quickEditPanel-leftSide-label">
                            {{ 'Discover.targeting.searchFieldLabels.mediaMarkets' | localize }}
                        </label>
                        <div class="agpr-quickEditPanel-leftSide-details">
                            @for (mediaMarkets of defaultSearchModel.mediaMarkets.include; track mediaMarkets) {
                                <agpr-checkbox
                                    [value]="mediaMarkets"
                                    [id]="id + '_mediaMarkets_' + mediaMarkets"
                                    [(ngModel)]="searchModel.mediaMarkets.include"
                                    labelLookupValue="displayString"
                                    labelLookupKey="id"
                                    [labelLookup]="journodexEnumsService.getMediaMarketsByIds.bind(journodexEnumsService)"
                                    (onChange)="handleToggle($event, 'mediaMarkets')"
                                >
                                </agpr-checkbox>
                            }
                        </div>
                    </ng-container>

                    <!-- coverageFocuses -->
                    <ng-container *ngIf="searchIncludeExcludeNotEmpty?.coverageFocuses">
                        <label class="agpr-quickEditPanel-leftSide-label">
                            {{ 'Discover.targeting.searchFieldLabels.coverageFocuses' | localize }}
                        </label>
                        <div class="agpr-quickEditPanel-leftSide-details">
                            @for (coverageFocuses of defaultSearchModel.coverageFocuses.include; track coverageFocuses) {
                                <agpr-checkbox
                                    [value]="coverageFocuses"
                                    [id]="id + '_coverageFocuses_' + coverageFocuses"
                                    [(ngModel)]="searchModel.coverageFocuses.include"
                                    labelLookupValue="displayString"
                                    labelLookupKey="enumValue"
                                    [labelLookup]="journodexEnumsService.getCoverageFocuses()"
                                    (onChange)="handleToggle($event, 'coverageFocuses')"
                                >
                                </agpr-checkbox>
                            }
                        </div>
                    </ng-container>

                    <!-- subject -->
                    <ng-container *ngIf="searchIncludeExcludeNotEmpty?.subjects">
                        <label class="agpr-quickEditPanel-leftSide-label">
                            {{ 'Discover.targeting.searchFieldLabels.subjects' | localize }}
                        </label>
                        <div class="agpr-quickEditPanel-leftSide-details">
                            @for (subjects of defaultSearchModel.subjects.include; track subjects) {
                                <agpr-checkbox
                                    [value]="subjects"
                                    [id]="id + '_subjects_' + subjects"
                                    [(ngModel)]="searchModel.subjects.include"
                                    labelLookupValue="name"
                                    labelLookupKey="id"
                                    [labelLookup]="journodexSubjectsService.getChildrenByIds.bind(journodexSubjectsService)"
                                    (onChange)="handleToggle($event, 'subjects')"
                                >
                                </agpr-checkbox>
                            }
                        </div>
                    </ng-container>

                    <!-- keywords -->
                    <ng-container *ngIf="searchIncludeExcludeNotEmpty?.outletMonitoringKeywords">
                        <label class="agpr-quickEditPanel-leftSide-label">
                            {{ 'Discover.targeting.searchFieldLabels.keywords' | localize }}
                        </label>
                        <div class="agpr-quickEditPanel-leftSide-details">
                            @for (outletMonitoringKeywords of defaultSearchModel.outletMonitoringKeywords.include; track outletMonitoringKeywords) {
                                <agpr-checkbox
                                    [value]="outletMonitoringKeywords"
                                    [id]="id + '_outletMonitoringKeywords_' + outletMonitoringKeywords"
                                    [(ngModel)]="searchModel.outletMonitoringKeywords.include"
                                    [label]="outletMonitoringKeywords"
                                    (onChange)="handleToggle($event, 'outletMonitoringKeywords')"
                                >
                                </agpr-checkbox>
                            }
                        </div>
                    </ng-container>

                    <!-- marketSectors -->
                    <ng-container *ngIf="searchIncludeExcludeNotEmpty?.marketSectors">
                        <label class="agpr-quickEditPanel-leftSide-label">
                            {{ 'Discover.targeting.searchFieldLabels.marketSectors' | localize }}
                        </label>
                        <div class="agpr-quickEditPanel-leftSide-details">
                            @for (marketSectors of defaultSearchModel.marketSectors.include; track marketSectors) {
                                <agpr-checkbox
                                    [value]="marketSectors"
                                    [id]="id + '_marketSectors_' + marketSectors"
                                    [(ngModel)]="searchModel.marketSectors.include"
                                    labelLookupValue="displayString"
                                    labelLookupKey="enumValue"
                                    [labelLookup]="journodexEnumsService.getMarketSectors()"
                                    (onChange)="handleToggle($event, 'marketSectors')"
                                >
                                </agpr-checkbox>
                            }
                        </div>
                    </ng-container>

                    <!-- targetAudiences -->
                    <ng-container *ngIf="searchIncludeExcludeNotEmpty?.targetAudiences">
                        <label class="agpr-quickEditPanel-leftSide-label">
                            {{ 'Discover.targeting.searchFieldLabels.targetAudiences' | localize }}
                        </label>
                        <div class="agpr-quickEditPanel-leftSide-details">
                            @for (targetAudiences of defaultSearchModel.targetAudiences.include; track targetAudiences) {
                                <agpr-checkbox
                                    [value]="targetAudiences"
                                    [id]="id + '_targetAudiences_' + targetAudiences"
                                    [(ngModel)]="searchModel.targetAudiences.include"
                                    labelLookupValue="displayString"
                                    labelLookupKey="enumValue"
                                    [labelLookup]="journodexEnumsService.getTargetAudiences()"
                                    (onChange)="handleToggle($event, 'targetAudiences')"
                                >
                                </agpr-checkbox>
                            }
                        </div>
                    </ng-container>
                </div>


            </agpr-scroll-panel>
        </div>
        <div class="agpr-quickEditPanel-rightSide">
            <agpr-scroll-panel>

                @if (targetingSearchFull) {
                    <agpr-quick-edit-search
                        [contactSearchParams]="contactSearchParams"
                        [outletSearchParams]="outletSearchParams"
                        [contactData]="targetingSearchFull"
                        [searchParamsVisible]="searchParamsVisible"
                        (valueChange)="updateSearch($event)"
                    ></agpr-quick-edit-search>

                    <agpr-quick-edit-refinements-search
                        [refinementSearchParams]="refinementSearchParams"
                        [searchParamsVisible]="searchParamsVisible"
                        [refinementData]="targetingSearchFull"
                        (valueChange)="updateSearch($event)"
                    ></agpr-quick-edit-refinements-search>
                }
            </agpr-scroll-panel>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            (click)="close()"
            [label]="'Core.button.cancel'"
            [style]="buttonTypes.secondary"
            [id]="id+'_cancelButton'"
        ></agpr-button>
        <agpr-button
            (click)="apply()"
            [disabled]="isQueryEmpty"
            [tooltip]="isQueryEmpty ? 'Discover.RR.quickEditPanel.apply.disabled' : ''"
            [label]="'Core.button.apply'"
            [label]="'Discover.RR.quickEditPanel.apply' | localize : {
                count: previewCountString
            }"
            [style]="buttonTypes.primary"
            [loading]="isPreviewLoading"
            [id]="id+'_applyButton'"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
